import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-pagination",
    templateUrl: "./pagination.component.html",
    styleUrls: ["./pagination.component.scss"],
    standalone: false
})
export class PaginationComponent implements OnInit {
  @Input() currentPage: number;
  @Input() totalPages: number;
  @Input() section: string;
  @Output() pageChange = new EventEmitter<number>();
  pages: number[] = [];
  firstPage: number;
  showEllipsis: boolean;
  maxPagesToShow: number;
  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    this.generatePagesArray();
  }

  onPageChange(page: number) {
    this.pageChange.emit(page);
  }

  private generatePagesArray() {
    this.maxPagesToShow = 5;
    this.showEllipsis = this.totalPages > this.maxPagesToShow;

    if (this.showEllipsis) {
      this.firstPage = Math.min(
        Math.max(1, this.currentPage - 2),
        this.totalPages - this.maxPagesToShow + 1
      );
    } else {
      this.firstPage = 1;
    }

    const lastPage = Math.min(
      this.firstPage + this.maxPagesToShow - 1,
      this.totalPages
    );
    this.pages = Array.from(
      { length: lastPage - this.firstPage + 1 },
      (_, i) => this.firstPage + i
    );
  }
}
